import React, { memo } from "react"

import ChatLock from "./ChatLock"
import ChatView from "./ChatView"
import SearchBar from "./SearchBar"
import Setting from "./Setting"
import WindowMode from "./WindowMode"

interface Props {
  isChatMode: boolean
}

function ToolBox({ isChatMode }: Props) {
  return (
    <ul className="iconB">
      <SearchBar title="검색" isChatMode={isChatMode}>
        {isChatMode && <i>-</i>}
        검색
      </SearchBar>
      <ChatLock title="줄잠금">
        {isChatMode && <i>-</i>}
        줄잠금
      </ChatLock>
      <ChatView title="채팅보기">
        {isChatMode && <i>-</i>}
        채팅보기
      </ChatView>
      {!isChatMode && <WindowMode title="창모드" />}
      <Setting title="설정" isChatMode={isChatMode}>
        {isChatMode && <i>-</i>}
        설정
      </Setting>
    </ul>
  )
}

export default memo(ToolBox)
